var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "frame" },
    [
      _c("project-loader", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        attrs: {
          "background-color": _vm.project.colors["text-secondary"],
          color: _vm.project.colors["text-primary"],
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.project.medias, function (media) {
        return _c("span", { key: media.id, staticClass: "media" }, [
          media.project_media_id.media
            ? _c(
                "video",
                {
                  ref: "video",
                  refInFor: true,
                  attrs: {
                    loop: "",
                    muted: "",
                    playsinline: "",
                    preload: "metadata",
                  },
                  domProps: { muted: true },
                  on: {
                    canplay: function ($event) {
                      return _vm.handleCanPlay(media.id)
                    },
                  },
                },
                [
                  _c("source", {
                    attrs: {
                      src: _vm.getUrl(media.project_media_id.media),
                      type: "video/mp4",
                    },
                  }),
                ]
              )
            : _c("img", {
                attrs: { src: _vm.getUrl(media.project_media_id.cover) },
              }),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }